import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Format currency
export function formatCurrency(amount, currency = 'CHF') {
  const formatter = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(amount);
}

// Format number with thousand separators
export function formatNumber(num, decimals = 2) {
  return new Intl.NumberFormat('de-CH', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}

// Format date
export function formatDate(dateString, format = 'short') {
  if (!dateString) return '-';
  const date = new Date(dateString);
  
  if (format === 'short') {
    return date.toLocaleDateString('de-CH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  
  if (format === 'long') {
    return date.toLocaleDateString('de-CH', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }
  
  return dateString;
}

// Get status badge class
export function getStatusBadgeClass(status) {
  switch (status) {
    case 'pending':
      return 'badge-pending';
    case 'approved':
      return 'badge-approved';
    case 'rejected':
      return 'badge-rejected';
    default:
      return 'bg-zinc-100 text-zinc-800';
  }
}

// Get amount class (positive/negative)
export function getAmountClass(amount) {
  if (amount > 0) return 'amount-positive';
  if (amount < 0) return 'amount-negative';
  return '';
}

// Truncate text
export function truncate(str, length = 30) {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.substring(0, length) + '...';
}

// Account type labels
export const accountTypeLabels = {
  asset: 'Asset',
  liability: 'Liability',
  equity: 'Equity',
  revenue: 'Revenue',
  expense: 'Expense',
};

// Currency symbols
export const currencySymbols = {
  CHF: 'CHF',
  EUR: '€',
  USD: '$',
};
